import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { get, post, put } from '../../../services/apiController';
import { toast } from 'react-toastify';
import LocationDetail from './LocationDetail';
import OwnerDetail from './OwnerDetail';
import TenantDetail from './TenantDetail';
import RecitalDetail from './RecitalDetail';

const AgreementAddEditModal = ({ open, onClose, agreementId, callback, step, ownerDetailId }) => {
  // Step 1 -> Basic Location Details -> Create/Update call
  // Step 2 -> Collect Owner Details With Bank details -> Update call
  // Step 3 -> Tenant details -> Update call
  // Step 4 -> recital details -> Update call
  // Step 5 -> recital details (Renewal of agreement) -> Update call

  const formFields = {
    companyId: 1,
    locationType: '',
    branchId: '',
    referenceLocation: '',
    ownerName: '',
    ownerAddress: '',
    ownerEmail: '',
    ownerPhoneNo: '',
    tenantName: '',
    tenantAddress: '',
    tenantEmail: '',
    tenantPhoneNo: '',
    floor: '',
    squareFeet: '',
    address: '',
    purpose: '',
    effectiveDate: '',
    agreementEndDate: '',
    underGst: false,
    gstNumber: '',
    gstRate: 0,
    rentOrLeaseAmount: '',
    stampDutyAmount: '',
    agreementExecutedDate: '',
    ownerAccountNumber: '',
    ownerIfsc: '',
    ownerBankName: '',
    ownerPanNo: '',
    ownerAadharNo: '',
    rentShareInPercent: 0,
    securityDepositAmount: '',
    securityDepositPaymentDetails: '',
    securityDepositTc: '',
    lockInPeriodInYears: '',
    lockInPeriodTc: '',
    maintenanceCharges: 0,
    waterCharges: 0,
    otherCharges: 0,
    registrationCharge: 0,
    chargesRemark: '',
    powerDepositAndConsumption: '',
  };
  const [form, setForm] = useState(formFields);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let _form = { ...form, [name]: value };
    setForm(_form);
  };
  const handleFileChange = (e) => {
    e.preventDefault();
    const { name, files } = e.target;
    if (name === 'ownerAadharImages' || name === 'agreementFiles') {
      setForm({ ...form, [name]: files });
    } else {
      setForm({ ...form, [name]: files[0] });
    }
  };

  useMemo(() => {
    if (form.rentOrLeaseAmount && form.gstRate) {
      const withGstRentAmount = parseFloat(form.rentOrLeaseAmount) + parseFloat((form.rentOrLeaseAmount * form.gstRate) / 100);
      setForm({ ...form, withGstRentAmount });
    } else {
      setForm({ ...form, withGstRentAmount: form.rentOrLeaseAmount });
    }
  }, [form.rentOrLeaseAmount, form.gstRate]);

  const handleSubmit = () => {
    setLoading(true);
    if (agreementId) {
      const formData = new FormData();
      for (const key in form) {
        if (key === 'cancelledChequeImage' || key === 'ownerAadharImages' || key === 'ownerPanImage' || key === 'agreementFiles') continue;
        formData.append(key, form[key]);
      }
      if (form.cancelledChequeImage !== null) formData.append('cancelledChequeImage', form['cancelledChequeImage']);
      if (form.ownerPanImage !== null) formData.append('ownerPanImage', form['ownerPanImage']);
      if (form.ownerAadharImages && form.ownerAadharImages !== null && form.ownerAadharImages.length > 0) {
        for (let i = 0; i < form.ownerAadharImages.length; i++) {
          formData.append('ownerAadharImages', form.ownerAadharImages[i]);
        }
      }
      if (form.agreementFiles && form.agreementFiles !== null && form.agreementFiles.length > 0) {
        for (let i = 0; i < form.agreementFiles.length; i++) {
          formData.append('agreementFiles', form.agreementFiles[i]);
        }
      }
      formData.append('step', step);
      put(formData, `/agreements/${agreementId}`, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setForm(formFields);
          onClose();
          callback();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message))
        .finally(() => setLoading(false));
    } else {
      post({ ...form, step }, '/agreements')
        .then((res) => {
          toast.success('Agreement created successfully');
          setForm(formFields);
          onClose();
          callback();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message))
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    if (agreementId) {
      get(`/agreements/${agreementId}`)
        .then((res) => {
          let form = { ...res.data };
          if (ownerDetailId && step === 2) {
            // Find owner details
            const ownerDetails = form.OwnerDetails.find((owner) => owner.id === +ownerDetailId);
            if (ownerDetails) {
              form = { ...form, ownerDetailId, ...ownerDetails };
            } else {
              form = { ...form, ownerDetailId };
            }
          }
          setForm(form);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message || err.message);
          setLoading(false);
        });
    }
  }, [agreementId]);

  const GetTitle = () => {
    switch (step) {
      case 1:
        return 'Location Details';
      case 2:
        return 'Owner Details';
      case 3:
        return 'Tenant Details';
      case 4:
        return 'Recitals Details';
      case 5:
        return 'Renew Agreement';
      default:
        return 'Agreement Details';
    }
  };

  return (
    <Modal size="lg" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>{agreementId ? GetTitle() : 'Create Agreement'}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
      </Modal.Header>
      <Modal.Body>
        {step === 1 && <LocationDetail form={form} setForm={setForm} handleChange={handleChange} />}
        {step === 2 && <OwnerDetail form={form} handleChange={handleChange} handleFileChange={handleFileChange} />}
        {step === 3 && <TenantDetail form={form} handleChange={handleChange} />}
        {(step === 4 || step === 5) && (
          <RecitalDetail
            step={step}
            form={form}
            handleChange={handleChange}
            handleCheckbox={(e) => setForm({ ...form, underGst: !form.underGst })}
            handleFileChange={handleFileChange}
          />
        )}
        <div className="container text-center">
          {loading ? (
            <Button className="add-request-btn mt-4 mb-3 justify-content-center" variant="primary" disabled>
              <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
              Loading...
            </Button>
          ) : (
            <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
              Submit
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AgreementAddEditModal;
